export interface IPolicyholderSearchCriteria {
    billingAccountNumbers: Array<string>;
    policyholderIds:Array<string>
}


export class PolicyholderSearchCriteria implements IPolicyholderSearchCriteria{
    billingAccountNumbers: Array<string>;
    policyholderIds:Array<string>
}